/* eslint-disable */
// @ts-nocheck
import { MasterKey } from './master-key'

export class Assignment {
  masterKey: MasterKey
  reserved: boolean
  kba: null
}

export class CylinderViewModel {
  id: number = null
  description: string = null
  chamberTypeId: number = null
  keywayFamilyTypeId: number = null
  hasConstructionOption: boolean = null

  constructor(obj: any) {
    for (var property in this) {
      this[property] = this[property] == null ? obj[property] : this[property]
    }
  }
}

export class SingleKeyViewModel {
  id: number
  masterKeySystemProfileId: number
}

export class KeySetSymbolViewModel {
  id: number
  masterKeyHierarchyId?: number
  changeKeyNumber?: number
  adaptedKeyName: string
  hierarchyName: string
  internalKeyName: string
  keySetSymbolTypeId: number
  crossKeyTypeId: number
  cylinderId?: number
  description: string
  crossKeyType: LookupItemViewModel
  keySetSymbolType: LookupItemViewModel
}

export class MasterKeyHierarchyViewModel {
  id: number
  masterKeySystemProfileId: number
  parentId?: number
  changeKeyExpansion: number
  isSelectiveMaster: boolean
  budgetLimit: number
  budgetsCompleted: boolean
  keySetSymbols: KeySetSymbolViewModel[]
  children: MasterKeyHierarchyViewModel[]
  hierarchyKeyName: string
  hierarchicalLevel: string
  levelOfKeying: any
  description: string
}

export class ManufacturerViewModel {
  id: number
  code: string
  name: string
  irManufacturer: boolean
  visible?: boolean
  producesKeys: boolean
}

export class SystemProfileViewModel {
  id: number
  projectId: number
  structureNumber: string
  externalSystemIdentification: string
  topMasterKey: string
  sequenceOfProgression: string
  keyPatternOrder: string
  isMasterKeyProvided: boolean
  useDhiNomenclature: boolean
  ruleId: number
  workgroupTypeId: number
  interchangeableCoreTypeId: number
  statusId: number
  manufacturerId: number
  isIndependentKeySystem: boolean
  interchangeableCoreType: LookupItemViewModel
  status: LookupItemViewModel
  workgroupType: LookupItemViewModel
  createdBy: string
  createdOn: Date
  modifiedBy?: string
  modifiedOn?: Date
  masterKeyHierarchies: MasterKeyHierarchyViewModel[]
  singleKeys: SingleKeyViewModel[]
  manufacturer: ManufacturerViewModel
}

export class LookupItemViewModel {
  id: number = null
  code: string = null
  name: string = null
  description: string = null

  constructor(obj: any) {
    for (var property in this) {
      this[property] = this[property] == null ? obj[property] : this[property]
    }
  }
}

export class AddMasterKeyRequest {
  changeKeyExpansion: number
  isChangeKey: boolean
  description: string
  parentId?: number
  openingKeyedFunctionIds?: number[]
}

export interface ConstructionType {
  id: number
  code: string
  description: string
  isActive: boolean
  createdOn: Date
}

export interface KeyRuleResponseObject {
  id: number
  systemTypeId: number
  keywayFamilyTypeId: number
  chamberTypeId: number
  constructionTypeId: number
  combinatingRuleTypeId: number
  defaultKeywayTypeId: number
  isDefaultChamber: boolean
  hasConstructionKey: boolean
  masterKeySystemProfiles: any
}

export class OpeningCylinderProduct {
  id: number
  name?: string
  description: string
  cylinderId: number
  cylinder: CylinderViewModel = new CylinderViewModel({})
  opening: {}
  openingKeyedFunctions: OpeningKeyedFunction[] = [null]
}

export class OpeningKeyedFunction {
  id: number
  openingCylinderProduct: OpeningCylinderProduct
  openingCylinderProductId: number
  isNoMasterKey: boolean
  baseKeySetSymbol?: string
  formattedKeySetSymbol?: string
  masterKey?: any
  singleKey?: { id: number }
  name?: string
  crossKeyCylinder?: any
  functionSelectiveMasters?: FunctionSelectiveMaster[]
}

export class FunctionSelectiveMaster {
  id: number
  openingKeyedFunctionId: number
  selectiveMasterId: number
  openingKeyedFunction?: OpeningKeyedFunction
  selectiveMaster: SelectiveMaster
}

export class AssignOpeningCylinderFunctionRequest {
  targetFunction: string
  cylinderId?: number
  operationType: number
  OpeningCylinderFunctions: Array<{
    openingId: number
    openingCylinderProductId?: number
    openingKeyedFunctionId?: number
  }>
}

export class SelectiveMaster {
  id: number
  name?: string
  masterKeySystemProfileId: number
  functionSelectiveMasters?: FunctionSelectiveMaster[]
  isChecked?: boolean
  display: Array<FunctionSelectiveMasterDisplay> = []
  constructor(obj: any) {}
}

export class FunctionSelectiveMasterDisplay {
  name: string
  functionSelectiveMasterId: number
  openingId: number
  openingCylinderProductId: number
  openingKeyedFunctionId: number
}

export class AddCrossKeyCylinderRequest {
  openingKeyedFunctionIds: Array<number>
  operatingKeys: Array<AddCrossKeyOperatorRequest>
  keyIncludedParentId?: number
}

export class AddCrossKeyOperatorRequest {
  crossKeyCylinder?: number
  operatorMasterKeyId: number
  masterOperator?: boolean
  directChangesOperate?: boolean
}

export class CrossKeyCylinder {
  id: number
  systemProfile: {}
  openingKeyedFunctions: OpeningKeyedFunction[]
  crossKeyOperators: CrossKeyOperator[]
  baseKeySetSymbol: string
  formattedKeySetSymbol: string
  keyIncluded?: MasterKey
}

export class CrossKeyOperator {
  id: number
  crossKeyCylinder: CrossKeyCylinder
  masterKey: MasterKey
  masterOperator: boolean
  directChangesOperate: boolean
}
